import React from 'react'

import Card from 'components/common/Card'

const Pane = ({ title = '', actions, children, className }) => (
  <Card className={className}>
    {title && <h1>{title}</h1>}
    {actions}
    {children && <main>{children}</main>}
  </Card>
)
export default Pane
